export const setPresetData = (items: any[], id: any, data: any): any[] => {
    return items.map((item) => {
        return item.id === id ? data : item;
    });
};
